import { BookOpen, ShieldCheck } from "lucide-react";

interface HeaderProps {
  parentEmail: string | null;
  onJoinClick: () => void;
  onSignInClick: () => void;
  onSignOut: () => void;
}

export function Header({ parentEmail, onJoinClick, onSignInClick, onSignOut }: HeaderProps) {
  return (
    <header className="site-header">
      <a className="brand-link" href="#top" aria-label="Nesty Learning home">
        <span className="brand-mark" aria-hidden="true">
          <BookOpen size={24} strokeWidth={2.4} />
        </span>
        <span>
          <strong>Nesty</strong>
          <span>Learning</span>
        </span>
      </a>
      <nav className="primary-nav" aria-label="Primary navigation">
        <a href="#why">How it works</a>
        <a href="#ages">Age bands</a>
        <a href="#safety">Safety</a>
        <a href="#console">Product</a>
      </nav>
      <div className="header-actions">
        {parentEmail ? (
          <>
            <span className="signed-in-label" title={parentEmail}>
              Signed in
            </span>
            <button className="text-button" onClick={onSignOut} type="button">
              Sign out
            </button>
          </>
        ) : (
          <button className="text-button" onClick={onSignInClick} type="button">
            Sign in
          </button>
        )}
        <button className="primary-button" onClick={onJoinClick} type="button">
          <ShieldCheck size={18} aria-hidden="true" />
          Join free beta
        </button>
      </div>
    </header>
  );
}
